import './SocialIcon.scss';

export default function FacebookIcon() {
  return (
    <svg
      className="social-icon facebook"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.1875 8.90625V6.03125C13.1875 5.23775 13.8315 4.59375 14.625 4.59375H16.0625V1H13.1875C10.8056 1 8.875 2.93056 8.875 5.3125V8.90625H6V12.5H8.875V24H13.1875V12.5H16.0625L17.5 8.90625H13.1875Z" />
    </svg>
  );
}
